var _path, _path2, _g, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "640pt",
    viewBox: "-30 0 640 640",
    width: "640pt",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300.586 101.45L285.277 0H60.676C26.856 0 0 27.555 0 61.371V486.09c0 33.816 26.855 60.812 60.676 60.812H273.73L427.223 314.5V148.766zm0 0",
    fill: "#00acea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.277.14l141.528 148.626h-94.211c-26.164 0-47.317-21.153-47.317-47.317zm0 0",
    fill: "#00efd1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#083863"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.852 318.676H98.527c-7.652 0-13.918 6.265-13.918 13.918 0 7.656 6.266 13.914 13.918 13.914h181.325c7.652 0 13.918-6.258 13.918-13.914 0-7.653-6.122-13.918-13.918-13.918zm0 0M98.527 276.93h140.97c7.651 0 13.917-6.262 13.917-13.918 0-7.653-6.266-13.914-13.918-13.914H98.527c-7.652 0-13.918 6.261-13.918 13.914 0 7.656 6.266 13.918 13.918 13.918zm0 0M234.066 389.648H98.527c-7.652 0-13.918 6.266-13.918 13.914 0 7.657 6.266 13.918 13.918 13.918h135.54c7.656 0 13.917-6.261 13.917-13.918 0-7.648-6.261-13.914-13.918-13.914zm0 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M426.805 286.813c86.28 12.101 152.656 86.136 152.656 175.753 0 97.97-79.457 177.434-177.426 177.434-67.351 0-126.078-37.574-156-92.96-13.637-25.188-21.43-53.993-21.43-84.61 0-97.97 79.461-177.43 177.43-177.43 8.352.14 16.559.7 24.77 1.813zm0 0",
    fill: "#fedb41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M458.672 449.488H416.09v-43.277c0-7.656-6.262-13.918-13.918-13.918-7.652 0-13.914 6.262-13.914 13.918v43.277H344.98c-7.656 0-13.918 6.262-13.918 13.914 0 7.657 6.262 13.922 13.918 13.922h43.278v42.582c0 7.653 6.262 13.918 13.914 13.918 7.656 0 13.918-6.265 13.918-13.918v-42.582h42.582c7.656 0 13.914-6.265 13.914-13.922 0-7.652-6.258-13.914-13.914-13.914zm0 0",
    fill: "#083863"
  })));
}

export default __webpack_public_path__ + "1f04bee203970e01801e296d73974a2d.svg";
export { SvgAddFile as ReactComponent };